import service from "@/utils/service";
// 获取基础数据表
export const tableList = (data) => service.get("/table/list", data);
// 获取帮助中心文档
export const articleList = (data) => service.get("/article/list", data);
// 获取帮助中心文档详情
export const articleDetail = (data) => service.get("/article/detail", data);
